// Frontend/src/components/common/PageHeader.jsx
import React from 'react';

const PageHeader = ({ icon: Icon, title, subtitle, compact = false }) => {
  if (compact) {
    return (
      <div className="flex items-center gap-3 sm:gap-4 min-w-0">
        {Icon && (
          <div className="p-2 sm:p-2.5 rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-600 shadow-md flex-shrink-0">
            <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-lg sm:text-xl font-bold text-gray-900 break-words truncate">{title}</h1>
          {subtitle && (
            <p className="text-xs sm:text-sm text-gray-600 mt-0.5 break-words">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <header className="mb-4 sm:mb-6 lg:mb-8">
      <div className="bg-white/90 backdrop-blur-sm border border-gray-100 rounded-2xl px-4 sm:px-5 py-3 sm:py-4 flex items-center gap-3 sm:gap-4 shadow-sm">
        {Icon && (
          <div className="p-2 sm:p-2.5 rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-600 shadow-md flex-shrink-0">
            <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 break-words">{title}</h1>
          {subtitle && (
            <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </header>
  );
};

export default PageHeader;




